import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useQueryParamsStore = defineStore('queryParams', () => {

    /*
        get / set "seed" cookie, which makes sure that
        the result order will stay constant for the length
        of our session
    */
    const getCookie = function (name) {

        let value = `; ${document.cookie}`;
        let parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();

    }

    const getSeed = function () {

        const existing = getCookie('seed');

        if (existing) {

            return existing;

        } else {

            let random_number = Math.floor(Math.random() * 9000);
            let seed = random_number.toString();

            document.cookie = 'seed=' + seed + ';';

            return seed;

        }
    }

    const params = ref(
        {
            categories: [],
            exclude_categories: null,
            places: [],
            grades: null,
            alerts: null,
            listingType: null,
            startDate: null,
            endDate: null,
            radius: null,
            keywords: null,
            distance: null,
            offset: 0,
            limit: 12,
            exclude: null,
            customSort: null,
            seed: getSeed(),
            sort: null,
            featured: null,
            bounds: null,
            facets: [],
            imageWidth: 0,
            imageHeight: 0,
        }
    );

    // we need to reset the offset every time the params are updated
    const resetOffset = function () {

        params.value['offset'] = 0;

    }

    const updateParamString = function (param, value) {

        resetOffset();

        params.value[param] = value;

    }

    const pushToParamArray = function (param, value) {

        resetOffset();

        params.value[param].push(value);

    }

    const pushToArrayIfEmpty = function (param, value) {

        if (params.value[param].length === 0) {

            pushToParamArray(param, value);

        }

    }

    const deleteFromParamArray = function (param, value) {

        resetOffset();

        const i = params.value[param].indexOf(value);

        if (i >= 0) {
            params.value[param].splice(i, 1);
        }

    }

    const resetParamArray = function (param, value) {

        resetOffset();

        if (value) {

            params.value[param] = [value];

        } else {

            params.value[param] = [];

        }

    }

    return {
        params,
        updateParamString,
        pushToParamArray,
        deleteFromParamArray,
        pushToArrayIfEmpty,
        resetOffset,
        resetParamArray,
    }

})

